/** `/api/v2/license` – Lizenz des angemeldeten Therapeuten. */
import { http } from './http'
import type { License } from './types'

export function getLicense(): Promise<License> {
  return http.get<License>('/license')
}

export const licenseApi = { getLicense }
